import Container from "@components/Atomic/Container/Container";
import React, { PropsWithChildren } from "react";
import { clsx } from "clsx";
import { Breadcrumb } from "../Breadcrumb/Breadcrumb";
import { StyledContainer } from "../Styled/Container";
import { Styles } from "@ts/sanity";

interface ContainerProps {
  padding?: boolean;
  align?: "left" | "center";
  width?: string;
  styles: Styles[];
}

interface PageTitleProps extends TitleProps, ContainerProps {
  background?: string;
  children?: JSX.Element;
  hideHomepageLink?: boolean;
  noPadding?: boolean;
  paths?: Array<{
    title?: string;
    url?: string;
  }>;
  title: string;
}

const style = {
  align: {
    center: `items-center justify-center text-center`,
    left: `items-start justify-start text-left`,
  },
};

const InnerWrapper = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(
      props.className,
      "relative flex flex-col",
      props.padding && "pb-maxi pt-tera md:pb-mega",
      props.align ? style.align[props.align] : style.align.center,
    )}
  />
);

const Wrapper = ({
  styles,
  children,
  ...rest
}: PropsWithChildren<ContainerProps>) => {
  if (!!styles?.length) {
    return children;
  }

  return <InnerWrapper {...rest}>{children}</InnerWrapper>;
};

export const PageTitle = ({
  background = "light",
  hideHomepageLink,
  noPadding,
  title,
  children,
  paths,
  align = "center",
  width,
  styles,
  ...rest
}: PageTitleProps) => {
  return (
    <Container
      styles={styles}
      legacy={!styles?.length}
      background={background}
      {...rest}
    >
      <Wrapper styles={styles} padding={!noPadding} align={align} width={width}>
        {paths?.length ? (
          <Breadcrumb paths={paths} hideHomepageLink={hideHomepageLink} />
        ) : null}
        {title && (
          <h1 className="font-display text-[2rem] leading-[2.5rem] md:text-[2.75rem] md:leading-[3.25rem]">
            {title}
          </h1>
        )}
        {children}
      </Wrapper>
    </Container>
  );
};
